import * as React from "react"

import { RETAILER_BRANDS_ROUTES, USER_ENV, USER_ROLE } from "@constants"
import { useUserApp } from "@hooks"
import AppLayout from "Layout"
import RetailerBrandsPage from "./index"
import PuigBrandsPage from "./Puig"


// Same route and same menu entry on both deployments; only the dashboard inside
// changes. Puig has no RETAILER_BRAND / DIPI_LAST_ITEM_RAW, so there it serves the
// Product/Visibility tabs instead of Retailer/Competitor brands. The session's `env`
// comes from the backend (Config.ENV): 'dipi' on retail, 'puig' on puig.
const BrandsDashboard = () => {
    const { userEnv } = useUserApp()
    return userEnv === USER_ENV.PUIG ? <PuigBrandsPage /> : <RetailerBrandsPage />
}


export const RetailerBrandsRoutes = {
    path: RETAILER_BRANDS_ROUTES.PATH,
    title: RETAILER_BRANDS_ROUTES.TITLE,
    icon: 'tags',
    iconWeight: 'light',
    element: <AppLayout />,
    description: RETAILER_BRANDS_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <BrandsDashboard />,
        index: true
    }]
}
